/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'Revisão de IA',
    AIReviewFailed: 'A revisão da IA ​​​​falhou',
    AIReviewPassed: 'Revisão de IA aprovada',
    AIReviewStatus: 'Estado de revisão de IA',
    AIReviewing: 'A revisão da IA ​​está a ser revista',
    America: {},
    CheckSupportInstall: 'Verificar se a adaptação é suportada',
    ImporterCommunityDisplayName: 'Nome de apresentação da comunidade importadora',
    ImporterContactEmail: 'E-mail de contacto do importador',
    IndicatorLight: 'Luz indicadora',
    Instruction: 'Perceber',
    MostPicture4OrVideo: '(Máximo 4 imagens / 1 vídeo)',
    PleaseContactPersonnelCommunicating: 'Favor entrar em contacto com os funcionários da CFMOTO para comunicação',
    Redemptionservice: 'Serviço de resgate',
    USD: {},
    UnbindingApplicationCommitment: {},
    aboutAccount: 'Sobre Account',
    aboutVehicle: 'Sobre o veículo',
    accountApplyRejected: 'Solicitação de exclusão de conta rejeitada',
    accountCancel: 'Solicitação de exclusão de conta',
    accountDeletExplain: 'Orientações para a eliminação de contas',
    accountDelete: 'Eliminação da conta',
    accountDeleted: 'Conta excluída',
    accountFormatError: 'Formato de conta incorreto/utilizador não existe.  Por favor, faça corresponder o texto correspondente com base na causa real',
    accountNumber: 'Número de conta',
    action: 'Operação',
    actionFail: 'Operação falhou',
    actionSuccess: 'Operada com sucesso',
    activeScore: 'Pontuação ativa',
    activeTrigger: 'Os usuários acionam ativamente (Sobre o APP – Vá para a classificação)',
    activity: 'Atividade',
    activityCancel: 'Cancelamento de eventos',
    activityCover: 'Cobertura da atividade',
    activityDetails: 'Detalhes da atividade',
    activityId: 'ID da atividade',
    activityList: 'Lista de atividades',
    activityManagement: 'Gestão de atividades',
    activitySearch: 'Pesquisa de atividades',
    activityTime: 'Hora da atividade',
    activityTitle: 'Título da atividade',
    activityVenue: 'Local da atividade',
    adaptable: 'Para',
    add: 'Adicionar',
    addAccountDeletExplain: 'Adicionar aviso de eliminação de conta',
    addAuthenticationTime: 'Adicionar tempo de autenticação',
    addCanadaPrivacyPolicy: 'Adicionar Política de Privacidade do Canadá',
    addCanadaTelematicsPolicy: 'Adicionar Acordo Telemático do Canadá',
    addCanadaUserPolicy: 'Adicionar Contrato de Usuário Canadense',
    addDashcamHelp: 'Ajuda da Dashcam adicionada',
    addDataDeletExplain: 'Adicionar aviso de eliminação de dados',
    addEmail: 'Novo Email',
    addExhibitionCategory: {},
    addExhibitionSeries: {},
    addHelpConfiguration: 'Adicionar ajuda explicando a configuração',
    addInformationCategory: 'Adicionar nova categoria de informações',
    addInformationContent: 'Adicione novo conteúdo informativo',
    addKolUserAuthentication: 'Adicionar autenticação de utilizador KOL',
    addPicture: 'Adicionar imagem',
    addPrivacyAgreement: 'Novo acordo de privacidade',
    addPrivacySubmitSure: 'A data de vigência e a descrição da alteração da nova política de privacidade não podem ser ajustadas após o envio. Confirme o envio.',
    addPushConfiguration: 'Adicionar configuração push',
    addQuestion: {},
    addSdkStaement: 'Adicionar instrução SDK',
    addServiceIntroduce: 'Introdução aos Novos Serviços',
    addShowroomModel: 'Adicionar modelos de salas de exposições',
    addThisUser: 'Adicionar este utilizador',
    addTopic: 'Adicionar um tópico',
    addUser: 'Adicionar utilizador',
    addUserAgreement: 'Novo acordo de utilizador',
    addUserRole: 'Adicionar',
    addVehicleModel: 'Novos modelos',
    addVehicleModelCategory: 'Categoria de veículos nova',
    addVideo: 'Adicionar vídeo',
    addedBy: 'Adicionado por',
    additionalFeedback: 'Feedback adicional',
    administratorUnbind: 'Desv. administrador',
    afternoon: 'Tarde',
    agreeServiceAgreement: 'Ao ativar o serviço, concorda com o Acordo de Serviço',
    agreeSignOut: 'Concordo em terminar',
    agreementContent: 'Acordo',
    all: 'Todos',
    allArea: 'País/região de destino',
    allComment: 'Todos os comentários',
    allImportSuccess: 'Importação concluída.  Todos importados com sucesso',
    allServicesSimultaneously: 'Todos os serviços',
    allUser: 'Todos os utilizadores',
    allVehicleModel: 'Todos os modelos',
    alreadyOver: 'tudo aqui',
    ambientLightControl: 'Controlo de luz ambiente',
    amount: 'Montante',
    android: 'Android',
    answer: {},
    answerOta1: 'OTA significa que o veículo baixa o software de firmware mais recente da nuvem através da rede celular, e você pode atualizar o veículo online através do CFMOTO RIDE para otimizar continuamente a experiência de condução',
    answerOta2: 'Quando uma nova versão do display tft puder ser atualizada, você receberá a notificação de atualização. Se %s for exibido na parte inferior da página atual, significa que o display TFT do veículo não precisa ser atualizado.',
    answerOta3: 'Você pode clicar em %s no canto superior direito para saber mais instruções de operação do OTA com antecedência',
    anyCar: 'Qualquer carro?',
    appMessagePushCountLimit: 'Atingiu o limite de notificações deste mês (2 vezes/mês). O conteúdo editado pode ser guardado como rascunho. Deseja guardá-lo?',
    appPush: 'Notificação da app',
    appRating: 'Gerenciamento do mecanismo de pontuação',
    appType: 'Sistema telefônico',
    appVersion: 'Versão do aplicativo',
    applicableCountry: {},
    applicableCountryName: {},
    applyTime: 'Hora de aplicação',
    applyUnbinding: 'Aplicar a desvinculação',
    appointmentReleaseTime: 'Horário de liberação do agendamento',
    approval: 'Aprovado',
    arrivalNumberDescription: 'Número de dispositivos que receberam a notificação',
    arrivalNumberDescription0: 'O número real de chegadas ao terminal do dispositivo após o envio da mensagem de notificação (as chegadas após 5 dias não serão contabilizadas)',
    arrivalNumberVolume: 'Número de chegadas',
    askAllowUserSpeakInCommunity: 'Permite que o utilizador banido publique na comunidade',
    askApproveIt: 'Aprova-o',
    askDeleteCategory: {},
    askDeleteInformactionCategory: 'Se esta categoria de informações deve ser excluída',
    askDeleteInformationContent: 'Se deve excluir o conteúdo informativo',
    askDeleteKolUserAuthentication: 'Tem a certeza de que pretende eliminar esta autenticação de utilizador KOL?',
    askDeleteOfficialAuth: 'Tem a certeza que deseja eliminar a autenticação oficial desta conta?',
    askDeleteQuestion: {},
    askDeleteThisActivity: 'Apaga esta atividade',
    askDeleteThisBanner: 'Apaga este Banner',
    askDeleteThisComment: 'Tem a certeza de que pretende apagar este comentário',
    askDeleteThisPost: 'Apaga este publicação',
    askDeleteThisTopic: 'Apaga este tópico',
    askDeleteVehicleType: 'Você tem certeza de excluir o modelo do veículo',
    askDeleteVehicleTypeCategory: 'Se deseja excluir esta categoria de modelo',
    askDeleteVehicleTypeDetails: 'Se deseja excluir os detalhes do modelo do carro',
    askDeleteVehicleTypeSeries: 'Se deseja excluir esta série de modelos',
    askLogout: 'Tem certeza de que deseja sair do sistema?',
    askNotApproveIt: 'Não o aprova',
    askSaveSettings: 'As configurações ainda não foram salvas, deseja salvá-las?',
    associatedPostNumber: 'Número de publicações associadas',
    associatedPosts: 'Publicações associadas',
    associatedVehicle: 'veículo associado',
    assoclatedContent: 'Conteúdo associado',
    atmosphereCContent: 'As configurações ainda não foram salvas, deseja salvá-las?',
    atmosphereContent1Msg1: 'Depois que a função é ativada, o celular liga o Bluetooth e o APP continua funcionando. Ao se aproximar do veículo de longe para perto, o veículo pode ser desbloqueado e ligado automaticamente.',
    atmosphereContent1Msg2: 'Se normalmente não estiver desbloqueado e ligado, pressione o botão liga / desliga do veículo para desbloquear e ligar',
    atmosphereContent1Msg3: 'O desbloqueio automático de proximidade só será acionado uma vez antes do bluetooth ser desconectado',
    atmosphereContent2Msg1: 'Após a função ser ligada, o veículo desligará automaticamente após 5 segundos após as três condições do veículo serem desligadas, a velocidade do veículo é 0 e O templo caiu',
    atmosphereContent2Msg2: 'Iniciar o veículo durante o período de desligamento automático, a velocidade do veículo não é 0 ou a têmpora é colocada cancelará o desligamento automático',
    atmosphereContent3Msg1:
      'Depois que a função é ligada, quando o veículo é desligado, o celular liga o Bluetooth e o APP continua funcionando ou carrega a chave física. Ao se aproximar do veículo de longe para perto, as luzes do veículo piscarão para receber os convidados',
    atmosphereContent3Msg2: 'Para evitar que gatilhos frequentes causem perda de energia do veículo, após a função de boas-vindas ser acionada duas vezes em 30 segundos, ela não será retomada até 30 minutos depois',
    atmosphereContent4Msg1: 'Depois que a função é ativada, as luzes de farol baixo e distante serão ligadas automaticamente por 10 segundos após o veículo ser desligado',
    atmosphereIntroduce1: 'Perto das instruções de desbloqueio automático',
    atmosphereIntroduce2: 'instruções de desligamento automático',
    atmosphereIntroduce3: 'Instruções de ativação automática',
    atmosphereIntroduce4: 'Luzes atrasadas apagadas',
    atmosphereSetINfo: 'As novas configurações entrarão em vigor dentro de 1 a 3 minutos após o veículo ser ligado, certifique-se de que o veículo esteja em uma boa posição de sinal',
    auditStatus: 'Estado da revisão',
    authType: 'Tipo de autenticação',
    authenticatedName: 'Nome autenticado',
    avatar: 'Avatar',
    backApply: 'retirar pedido',
    backApplySuccess: 'retirada do pedido com sucesso',
    backHome: 'Voltar à página inicial',
    bannerDisplayImages: 'Imagem do banner',
    bannerList: 'Lista de Banner',
    bannerManagement: 'Gestão de Banner',
    bannerPictrure: 'Desenho do Banner',
    bannerSearch: 'Pesquisa de Banner',
    bannerTitle: 'Título do banner',
    baseService: 'Standard Edition\n',
    baseServicePay: 'Pagamento para Standard Edition',
    baseServiceResetTimeRule: 'O tempo de redefinição do serviço básico não pode ser posterior ao tempo atual',
    batchImport: 'Importação de lotes',
    batchUser: 'Utilizadores em massa',
    beijingTime: 'Horário UTC+8',
    belogCategory: 'categoria',
    belongCategory: {},
    bindDevice: 'Dispositivo de ligação',
    bindEmail: 'Vincular e-mail',
    bindVehicle: 'Vincular veículo',
    bindingStatus: 'Estado',
    bindingText1: '1.\tServiços de telemática',
    bindingText10: '1.1.2.\tFornecer planejamento de rotas durante a navegação, incluindo o cálculo da distância entre veículos e navegação a pé com o objetivo de encontrar um veículo .',
    bindingText11: '1.2.\tEnvio de notificações necessárias ao Cliente com base nas condições do veículo.',
    bindingText12:
      '1.2.1.\tA CFMOTO enviará ao Cliente notificações sobre a manutenção do veículo (por exemplo, com base na distância total que o Cliente percorre, a hora em que o Cliente compra o veículo, os requisitos de tempo ou distância percorrida para a manutenção do veículo) .',
    bindingText13:
      '1.2.2.\tCom base nos dados do veículo , a CFMOTO enviará ao Cliente notificações de situações anormais; incluindo análise de dados pelo OEM (dependendo do modelo) para fornecer atendimento ao cliente e otimização de acompanhamento do veículo .',
    bindingText14: '1.3.\tApoio na análise da causa do acidente caso o Cliente comunique um acidente grave do Veículo.',
    bindingText15:
      '1.3.1.\tEm caso de acidente grave com o Veículo, como por exemplo capotamento ou capotamento do Veículo durante a condução, a CFMOTO apoiará o Cliente, mediante pedido, esclarecendo se o acidente se deve a defeito do Veículo ou outras circunstâncias. O pedido deve ser apresentado à CFMOTO pelo Cliente através do distribuidor/parceiro comercial local indicado no Contrato de Venda de Veículos.',
    bindingText16: '1.3.2.\tNa medida em que os dados disponíveis o permitam, a CFMOTO avaliará os dados em relação à causa do acidente e fornecerá ao Cliente o correspondente relatório.',
    bindingText17: '1.4.\tAssistência ao Cliente na recuperação do Veículo após o seu extravio .',
    bindingText18:
      '1.4.1.\tEm caso de perda do Veículo, a CFMOTO fornecerá ao Cliente os dados de localização do Veículo e outros dados úteis sobre o estado do Veículo (como localização da última ativação, estado atual do veículo, etc.) mediante solicitação e se disponível.',
    bindingText19: '1.4.2.\tO pedido deve ser apresentado à CFMOTO pelo Cliente através do distribuidor/parceiro comercial local indicado no Contrato de Venda de Veículos.',
    bindingText2:
      'A CFMOTO Powersports, Inc. (doravante denominada “ CFMOTO ” ) fornece serviços de telemática de veículos ao cliente que comprou o veículo CFMOTO (doravante denominado “Cliente” ). Para estes serviços, a CFMOTO utiliza os dados registados pelo Veículo sobre o Veículo e o seu comportamento de condução no período de tempo relevante. Em detalhes, trata-se dos seguintes dados:',
    bindingText20: '1.5.\tRelatórios de problemas pós-venda .',
    bindingText21: '1.5.1.\tA CFMOTO recolhe remotamente as notificações de códigos de erro enviadas pelo Veículo em caso de avaria dos seus componentes e fornece as respetivas informações a pedido do Cliente diretamente ao Cliente.',
    bindingText22: '1.5.2.\tO pedido deve ser apresentado à CFMOTO pelo Cliente através do distribuidor/parceiro comercial local indicado no Contrato de Venda de Veículos.',
    bindingText23: '2.\tRestrições e Exclusões de Serviço',
    bindingText24: '2.1.\tRessalta-se expressamente que alterações estruturais ou outras técnicas do Veículo podem limitar a prestação dos serviços ou mesmo inviabilizá-la, uma vez que os serviços dependem do correto fornecimento dos dados do veículo.',
    bindingText25: '2.2.\tQuando tais serviços não puderem ser prestados devido ao desempenho de quaisquer dados de terceiros ou redes de telecomunicações, qualquer responsabilidade da CFMOTO é excluída.',
    bindingText26: '3.\tPrivacidade',
    bindingText27:
      'A CFMOTO cumprirá os regulamentos de proteção de dados aplicáveis ao processar dados pessoais em conexão com o veículo CFMOTO . Os termos da política de privacidade da C FMOTO estão definidos neste aplicativo CFMOTO RIDE . Como complemento da política de privacidade , este aviso está em conformidade com a política de privacidade . E o Cliente pode consultar a política de privacidade para alguns conteúdos relacionados ao processamento de dados não cobertos por este aviso.',
    bindingText28: '4.\tAtendimento ao Cliente',
    bindingText29:
      '4.1.\tO cliente pode enviar perguntas, comentários ou preocupações relacionadas à privacidade para CFMOTORIDEAPP@cfmotousa.com ou escrever para: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. O cliente também pode ligar Relacionamento com o cliente CFMOTO em (888) 823-6686. ',
    bindingText3: 'Dados do comportamento de direção do usuário : incluindo aceleração, desaceleração, velocidade, curvas, último tempo de direção e última milhagem de direção .',
    bindingText30: '5.\tR evisões',
    bindingText31: '5.1.\tA CFMOTO reserva-se o direito de alterar este aviso a qualquer momento, mas publicaremos as revisões no CFMOTO RIDE App e/ou fornecer aviso antes de fazê-lo, conforme apropriado.',
    bindingText4:
      'Dados de status do veículo: refere-se ao status em tempo real do veículo, incluindo modo de condução, combustível residual, economia instantânea de combustível, quilometragem, marcha em tempo real do veículo, velocidade do motor, pressão dos pneus, temperatura dos pneus, dados de tensão de ativação da bateria , temperatura do líquido refrigerante, status do bloqueio eletrônico, versão do software do dispositivo inteligente, intensidade do sinal de dispositivos inteligentes, configuração atual do painel.',
    bindingText5:
      'Dados de alarme do veículo: dados de alarme a serem enviados se determinados dados excederem um valor predefinido, como temperatura do motor, velocidade excessiva, tempo excessivo de condução, alta temperatura do líquido de arrefecimento, movimento anormal do veículo, pressão anormal dos pneus, vibração, despejo, colisão , etc. .',
    bindingText6: 'Informações de falha do veículo: refere-se aos códigos de falha relatados por cada parte interna do veículo.',
    bindingText7: 'Dados de Localização do Veículo: refere-se ao paradeiro geográfico específico do Veículo.',
    bindingText8: '1.1.\tFornecendo _ o Cliente com serviços relacionados ao veículo através do APP CFMOTO RIDE .',
    bindingText9:
      '1.1.1.\tOs Consumidores podem gerenciar remotamente os veículos através do aplicativo CFMOTO RIDE (incluindo a visualização da localização do veículo, configuração das informações e funções do veículo, controle remoto do status do veículo, etc.).',
    bindingUser: 'Vincular utilizador',
    bothServices: 'Ambos os serviços',
    bound: 'Vinculado',
    businessType: 'Tipo de negócio',
    button: 'botão',
    callbackedApply: 'Você retirou seu pedido de exclusão de conta em yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      'O seu pedido de exclusão de conta foi enviado em yyyy-MM-dd HH:mm:ss. Após recebermos o pedido, a sua conta e os dados relacionados serão permanentemente eliminados 15 dias depois. Após a eliminação, você não poderá mais usar o serviço CFMOTO RIDESYNC. Para cancelar a eliminação da sua conta, por favor volte a visitar a página web ou entre na APP dentro de 15 dias para retirar a solicitação de eliminação da conta.',
    callbackedApplyTip:
      'O seu pedido de exclusão de conta foi enviado em yyyy-MM-dd HH:mm:ss. Após recebermos o pedido, a sua conta e os dados relacionados serão permanentemente eliminados 15 dias depois. Após a eliminação, você não poderá mais usar o serviço CFMOTO RIDE. Para cancelar a eliminação da sua conta, por favor volte a visitar a página web ou entre na APP dentro de 15 dias para retirar a solicitação de eliminação da conta.',
    canadaPrivacyPolicy: 'Política de Privacidade do Canadá',
    canadaTelematicsPolicy: 'Acordo Telemático do Canadá',
    canadaUserPolicy: 'Contrato de Usuário Canadense',
    canadianAgreementText: 'Texto do Acordo Canadiano',
    cancel: 'Cancelar',
    cancellationAgreement: 'Acordo de cancelamento',
    cancelled: 'Cancelado',
    carOwner: 'Proprietário',
    carUserScore: 'Avaliações do proprietário do veículo',
    cardPass: 'Verificação de identidade bem sucedida!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Mude para autenticação por código de verificação',
    changeDescriptionType: 'mudar descrição',
    changeDescriptionTypeSelectNo: 'Não envolve alterações nos regulamentos de processamento de informações pessoais',
    changeDescriptionTypeSelectYes: 'Mudanças nos regulamentos que envolvem o processamento de informações pessoais',
    changeEmail: 'Modificar e-mail',
    changeEmailInfo: 'Mudar para e-mail',
    changeFail: 'Falha na modificação do status',
    changeOne: 'Mudar',
    changePassValidate: 'Mude para autenticação de senha',
    changePasswordFailed: 'Falha na mudança de senha',
    changePasswordSuccessful: 'Mudança de senha bem sucedida',
    changePhoneInfo: 'Mudar para número de telefone',
    changeStore: 'Modificar loja',
    changeSuccess: 'Status modificado com sucesso',
    channelType: 'canal de feedback',
    characterLimitExceeded: 'Limite de caracteres excedido',
    checkConfigurationTwo: 'Chinês ou Inglês %s não está totalmente configurado, por favor verifique',
    checkCopyWriting: 'O conteúdo em chinês ou inglês não está preenchido, verifique',
    checkEmpty: '%s está vazio, verifique',
    checkEmptyEnglish: 'Inglês incompleto. Por favor, verifique',
    checkTriggerType: 'Há uma condição do mecanismo de disparo que não foi preenchida, verifique',
    checkUpdate: 'confira atualizações',
    cityFilter: 'Filtro de cidade',
    clickImmediateFeedback: 'Clique para dar feedback agora',
    clickNumber: 'O número de cliques',
    clickNumberDescription: 'Número de notificações clicadas pelos utilizadores',
    clickNumberVolume: 'Número de cliques',
    clickToFeedback: 'Clique para feedback',
    clicks: 'Cliques',
    closeNum: 'fecho',
    closeTask: 'Tarefa cancelada',
    code: 'Código de verificação',
    colorPicture: 'Imagem do bloco de cores',
    comment: 'Comentário',
    commentContent: 'Comentários',
    commentList: 'Lista de comentários',
    commentNumber: 'Número de comentários',
    commentTime: 'Hora de comentário',
    communication: 'em comunicação',
    community: 'Comunidade',
    communityManagement: 'Gestão comunitária',
    communityRule: 'Regra comunitária',
    completePuzzle: 'Por favor, complete o quebra-cabeça',
    completed: 'concluído',
    condition: 'doença',
    configureLanguage: 'Configurar idioma',
    configurePicture: 'Configurar imagem',
    confirm: 'Confirmar',
    confirmDeletePictures: 'Confirme para excluir esta foto',
    confirmRedeem: 'Confirmar para resgatar',
    confirmReviewNoPass: 'Confirmar a reprovação da revisão',
    confirmReviewPass: 'Confirmar a aprovação da revisão',
    consultDealer: 'Consulte o seu revendedor local',
    contact: 'Seu pedido de exclusão de conta foi rejeitado. Se você tiver alguma dúvida, entre em contato com it@cfmoto.com para consulta.',
    contactMail: 'Endereço de correio eletrónico',
    contactMethod: 'Contacto',
    contactUs: 'Contacte-nos',
    content: 'Conteúdo',
    contentType: 'Tipo de conteúdo',
    copyFail: 'Falha na cópia',
    copyLink: 'Link de cópia',
    copySuccess: 'Copiado com sucesso',
    copyWriting: 'Conteúdo pop-up',
    country: 'País/Região',
    countryCode: 'Código do país',
    countryName: 'País',
    countryNumber: 'Código de país',
    countryRegion: 'País/Região',
    create: 'Nova adição',
    createBy: 'Criador',
    createStore: 'Criar loja',
    createTime: 'tempo de criação',
    cs_CZ: 'Tcheco',
    currency: 'Moeda',
    currentConfig: {},
    currentCountryStoreTotal: 'Número total de lojas no país atual',
    currentRedemptionRatio: 'Rácio de resgate atual',
    currentTime: 'Hora atual',
    customPage: 'Página personalizada',
    customSettings: 'Colunas Personalizadas',
    dashcamHelp: 'Ajuda da Dashcam',
    dataDeletExplain: 'Orientações para a eliminação de dados',
    dataDelete: 'Eliminação de dados',
    dataDeleteApply: 'Solicitação de exclusão de dados',
    dataFormatError: 'Erro no formato de dados',
    dataPermissionScope: 'Escopo de permissão de dados',
    dataType: 'Tipo de dados',
    dayOne: 'dias uma vez',
    days: 'dia',
    daysAgo: '%s dias atrás',
    de_DE: 'Alemão',
    dealDate: 'Hora do processamento',
    dealerOperationList: 'Lista de operações do distribuidor',
    dealerOperationQuery: 'Consulta de operações do distribuidor',
    dealerOperationRecord: 'Registo de operações do concessionário',
    dealerStore: 'Lojas de revendedores',
    dealerStoreImportTempateName: 'Modelo de importação de lojas de concessionárias',
    dealerStoreQuery: 'Consulta das lojas de revendedores',
    dealers: 'Importador',
    default: 'Predefinição',
    defaultMap: 'Mapa padrão',
    delete: 'Excluir',
    deleteAccountSYNCStep: 'Você pode seguir essas etapas para solicitar a exclusão de sua conta CFMOTO RIDESYNC',
    deleteAccountStep: 'Você pode seguir essas etapas para solicitar a exclusão de sua conta CFMOTO RIDE',
    deleteDataSYNCStep: 'Pode seguir estes passos para solicitar a eliminação dos seus dados CFMOTO RIDESYNC',
    deleteDataStep: 'Pode seguir estes passos para solicitar a eliminação dos seus dados CFMOTO RIDE',
    deleteFail: 'Falha na exclusão',
    deleteFinish: 'Exclusão concluída',
    deleteKolUserAuthentication: 'Eliminar a autenticação do utilizador KOL',
    deleteStore: 'Eliminar loja',
    deleteSuccess: 'Exclusão bem sucedida',
    deleteTip: 'Tem certeza de que deseja excluir esta postagem? Uma vez excluídas, as informações não podem ser recuperadas',
    deleteVersionWarn: 'Se deseja excluir este registro de versão',
    deleteVideo: 'Excluir este vídeo?',
    detailAddress: 'Endereço pormenorizado',
    details: 'Detalhes',
    determine: 'Certa',
    deviceCodeGet: 'Obtenha o código do dispositivo:',
    deviceContent:
      'O código do equipamento do receptor da cerca eletrônica (referido como: chave) é uma sequência de códigos de 10 dígitos. O código do equipamento, o código QR e a marca CE estão impressos no adesivo autoadesivo de PVC prateado. São três etiquetas no total, uma foi afixada na carroceria do veículo (é necessário levantar a almofada do assento para visualizar); os outros dois são colocados na bolsa de acessórios do veículo. (Recomenda-se que os usuários afixem a etiqueta no manual do veículo ou no controle remoto)\nPressione e segure ON para abrir a chave e coloque o código QR na parte de trás da chave na moldura de digitalização',
    deviceNo: 'Número do dispositivo associado',
    deviceNumber: 'Número do dispositivo',
    deviceTitle: 'Verificação de Código',
    digitalKey: 'chave digital',
    digitalKeyDesc: 'Não há necessidade de carregar uma chave física, suporta o desbloqueio do veículo após conectar via APP Bluetooth (suportado por alguns modelos)',
    directRelease: 'Lançamento direto',
    disagree: 'Discordar',
    displayNumberDescription: 'Número de notificações mostradas nos dispositivos',
    displayNumberVolume: 'Número de visualizações',
    displayOrder: {},
    displayPicture: {},
    donwloadTemplateDescription: {},
    download: 'Descarregar',
    downloadFailFile: 'Baixar arquivo com falha',
    downloadSuccessful: 'Download bem-sucedido',
    downloadTemplate: 'Baixar modelo',
    downloading: 'Baixando...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'editar',
    editAccountDeletExplain: 'Editar aviso de eliminação de conta',
    editActivity: 'Editar atividade',
    editAppRating: 'Editar mecanismo de classificação',
    editBanner: 'Editar Banner',
    editCanadaPrivacyPolicy: 'Editar a Política de Privacidade do Canadá',
    editCanadaTelematicsPolicy: 'Editar Acordo Telemático do Canadá',
    editCanadaUserPolicy: 'Editar Contrato de Usuário do Canadá',
    editDashcamHelp: 'Ajuda da Dashcam editada',
    editDataDeletExplain: 'Editar aviso de eliminação de dados',
    editExhibitionCategory: {},
    editExhibitionSeries: {},
    editFunctionIntro: {},
    editHelpConfiguration: 'Editar ajuda instruções configuração',
    editInformation: 'Editar informações',
    editInformationCategory: 'Editar categoria de informações',
    editInformationContent: 'Editar conteúdo de informação',
    editKolUserAuthentication: 'Editar a autenticação do utilizador KOL',
    editModelSeries: 'Editar série de modelos',
    editPicture: 'Editar imagem',
    editPushConfiguration: 'Editar configuração push',
    editRemark: 'Editar Notas',
    editServiceIntroduce: {},
    editShowroomModel: 'Editar modelos de salas de exposições',
    editSuccess: 'Editado com sucesso',
    editTime: 'Editar tempo',
    editUnbindingCommitment: {},
    editUser: 'Editar usuário',
    editVehicleModel: 'Editar modelo',
    editVehicleModelCategory: 'Editar a categoria do veículo',
    effecting: 'Ativação pendente',
    effectiveTime: 'Data efetiva',
    electricVehicle: 'Veículo elétrico',
    email: 'E-mail',
    emailAdress: 'Endereço de e-mail',
    emailAdressTip: 'Observação:  Este endereço de e-mail é utilizado para o contacto com o cliente por e-mail.  Certifique-se de que o endereço de e-mail está correto',
    emailBindingFailed: 'Falha no bloqueio de e-mails',
    emailContent: 'Conteúdo do e-mail',
    emailImportTemplate: 'Modelo de importação de endereço de e-mail',
    emailImportTemplateToDownLoad: 'Endereços de e-mail podem ser importados em lotes, clique para fazer download',
    emailList: 'Lista de e-mail',
    emailManage: 'Gerenciamento de e-mail',
    emailMass: 'Explosão de email',
    emailSearch: 'Consulta por e-mail',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'E-mail',
    emailTitle: 'Assunto',
    en_US: 'Inglês',
    enableStatus: 'Status ativado',
    enabled: 'habilitar',
    endTime: 'Hora de término',
    endTimeLargeStartTime: 'A hora de fim deve ser posterior à hora de início',
    enterAnswer: {},
    enterCategory: {},
    enterCodeToSafeAccount: 'Para garantir a segurança da sua conta, por favor confirme la información de su cuenta  que pretende eliminar e insira sua senha ou um código de verificação para autenticar sua identidade.',
    enterCodeToSafeData: 'Para garantir a segurança dos seus dados, por favor confirme la información de su cuenta e  insira sua senha ou um código de verificação para autenticar sua identidade.',
    enterIntroduceText: {},
    enterLink: {},
    enterPopupTitle: {},
    enterQueryConditionLookData: 'Depois de inserir as condições da consulta, você pode visualizar os dados',
    enterQuestion: {},
    enterQuestionAndAnswer: {},
    enterSureUrl: {},
    enterTypeOfLanguage: {},
    enterUnbindingCommitment: {},
    entrance: {},
    errorLatAndLon: 'A latitude e a longitude estão formatadas incorretamente, verifique',
    errorLocation: {},
    es_ES: 'Espanhol',
    estimatedTime: 'Tempo estimado',
    everySet: 'Por configuração',
    examineResultMessage: 'Verificaremos os materiais de inscrição o mais rápido possível, preste atenção na barra de notificação ou no centro de mensagens do APP a tempo.',
    example: 'precedente',
    exchange: 'Resgatar agora',
    exchangeDescription1:
      'Estimado proprietário de CFMOTO, o seu veículo foi vinculado com sucesso. Recebeu um período experimental gratuito de 1 ano para serviços inteligentes. \nPor favor, escolha os serviços que deseja ativar: \n- Edição Standard \n- MotoPlay Premium \nPor favor, leia e concorde com os termos \nConsulte o "Acordo de Serviço Inteligente" \n[Confirmar]\t',
    exchangeDescription2:
      'Consulte o manual eletrónico para obter todos os detalhes do veículo. Também beneficiará de um período experimental gratuito de 1 ano para todos os serviços inteligentes CFMOTO RIDE,  a partir da sua primeira data de vinculação. \n [Fechar] [Entendi]',
    exchangeDescription3:
      'Tem XXX km de quilómetros disponíveis. Resgate agora para continuar a usufruir do Serviço Inteligente CFMOTO RIDE. Se nenhuma ação for tomada, os seus dados de quilometragem serão conservados durante 30 dias após a desvinculação da conta. A quilometragem não resgatada será automaticamente apagada e não poderá ser recuperada após este período. \nTem a certeza que deseja resgatar agora?  \n[Sim] [Não]  \n\n*Os benefícios de quilometragem resgatada serão transferidos com o veículo para o próximo proprietário.',
    exchangeDescription4: 'Tem XXX km de quilómetros disponíveis. Gostaria de resgatar a sua quilometragem para continuar a\n usufruir gratuitamente do Serviço Inteligente CFMOTO RIDE?\n [Sim] [Não]',
    exchangeDescription5:
      'Lembrete do Serviço Inteligente \nEstimado proprietário de CFMOTO: Faltam XXX dias para a sua experiência gratuita do Serviço Inteligente de CFMOTO. Se ativar o Serviço Inteligente, este será ativado no prazo de 24 horas. Por favor, verifique. \n[Confirmar]',
    exchangeDescription6: 'Desfrute de uma melhor experiência de percurso com MotoPlay, que oferece serviços de projeção de ecrã e navegação suportados por Google Maps',
    exchangeRecords: 'Registo de resgate',
    exchangeServiceTime: 'Tem quilometragem disponível para resgatar horas de serviço',
    exchangeSuccess: 'Resgatado com sucesso',
    exhibition: {},
    exhibitionCategory: {},
    exhibitionCategoryList: {},
    exhibitionCategorySearch: {},
    exhibitionSeries: {},
    exhibitionSeriesList: {},
    exhibitionSeriesSearch: {},
    exportContent: 'Conteúdo de exportação',
    exportExcel: 'Exportar para EXCEL',
    exportLengthExceedOfMonth: 'A duração da exportação não deve exceder %s meses',
    externalLink: 'Ligação externa',
    failed: 'Falhou',
    failedToPreview: 'A revisão falhou',
    feedBackResut: 'Resultados do feedback',
    feedBackTime: 'Tempo de feedback',
    feedBackVechle: 'Veículo',
    feedbackAppQuestion: 'Por favor descreva em detalhe a hora da ocorrência, versão APP, modelo de telemóvel, caminho de operação e descrição do problema para ajudar a localizar e resolver rapidamente o problema!',
    feedbackDetails: 'Detalhes do feedback',
    feedbackGuideDesc: 'Para mais informações, entre em contato conosco através do canal de feedback abaixo',
    feedbackLabelFileList: 'Por favor carregue uma foto/vídeo',
    feedbackMapQuestion: {},
    feedbackMessageSubmitError: 'Feedback falha',
    feedbackOtherQuestion: 'Por favor, descreva quando aconteceu, como aconteceu e o problema',
    feedbackReceived: 'Feedback recebido',
    feedbackRecord: 'Registo de feedback',
    feedbackRulesFileListMaxSize: 'O ficheiro enviado é demasiado grande',
    feedbackRulesFileListOverType: 'Formato não suportado',
    feedbackSubmitTip: 'Se você tiver alguma dúvida ou comentário, também pode entrar em contato diretamente com o Centro de Atendimento ao Cliente CFMOTO México via WhatsApp (+52 18115286003) ou e-mail (servicioalclient@cfmoto.com.mx)',
    feedbackSuggest: 'Bem-vindo a fazer sugestões valiosas, iremos considerar seriamente as suas ideias',
    feedbackSupplement: 'Adicione uma descrição do problema',
    feedbackText: 'Feedback',
    feedbackType: 'Tipo de feedback (escolha única)',
    feedbackVehicleQuestion: 'Por favor, descreva quando aconteceu, como aconteceu e o problema',
    female: 'Mulher',
    fileCountExceed: 'O número de ficheiros excede o limite',
    fileSizeExceed: 'O tamanho do arquivo excede o limite',
    fileUploadingPleaceWait: 'Carregando arquivo, aguarde',
    finalOperator: {},
    firstBindDate: 'Hora do primeiro vinculamento do veículo',
    firstMenu: 'Menu de primeiro nível',
    forcedUpgrade: 'Atualização forçada',
    forgetPassword: 'Esqueci a palavra-passe',
    fourCarOfNumber: 'Número de utilizadores de veículos de quatro rodas',
    fourWheel: 'Motociclos de quatro rodas',
    fourWheelConfig: {},
    fourWheeler: 'Quatro rodas',
    fourWheelerMostClicks: 'Modelos de veículos de quatro rodas com mais cliques',
    fourWheelowner: {},
    fr_FR: 'Francês',
    frankfurt: 'Frankfurt',
    freeLastDayBasedata: 'Duração gratuita da edição standard',
    freeLastDayMotoplay: 'Duração gratuita do MotoPlay',
    friday: 'Sexta-feira',
    fuctionIntro: {},
    fullscreen: 'Ecrã cheio',
    funServiceIntro: {},
    function: 'Função',
    functionConfiguration: {},
    functionConfigureTip: 'A função só é aplicável aos veículos configurados em nome do importador ou dos utilizadores no país/região',
    functionDescription: {},
    functionDetail: {},
    functionIntroduce: 'Descrição da função',
    functionSetting: {},
    functionalOverview: 'Visão geral das funções',
    galleryEntrance: 'Entrada da galeria',
    galleryEntranceUploadRules: 'Requisitos de formato: jpg/jpeg/png, proporção recomendada 4:3, tamanho não superior a 5 MB',
    gender: 'Sexo',
    generalAgreementText: 'Texto do Acordo Geral',
    generalAlarm: 'Alarme comum',
    geofence: 'Cerca Eletrônica',
    getCarPosition: 'Obtenha a localização do veículo a tempo',
    getCode: 'Enviar',
    getExchangeRecordsError: 'Falha ao obter registos de resgate',
    goCustomPage: 'Ir para a página personalizada',
    goOffline: 'Offline',
    goOnline: 'Online',
    goUrlLink: 'Ir para a ligação URL',
    groupTrail: {},
    groupTrailConfig: {},
    guest: 'sem carro',
    haveTwo: 'Ambos',
    havedWrite: 'Preenchido',
    havedWriteAll: 'foi preenchido',
    havedWriteAllOrEmpty: 'esteja preenchido ou vazio',
    helpAndFeedback: 'Ajuda e feedback',
    helpCenter: 'Centro de ajuda',
    helpConfiguration: 'Ajuda para explicar a configuração',
    helpMessageHistoryDelete: 'Excluir todos os registros de pesquisa?',
    helpful: {},
    hint: 'Dica',
    historyDelete: 'Excluir todos os registros de pesquisa?',
    home: 'Início',
    homePage: 'Página pessoal',
    hour: 'Hora',
    hoursAgo: '%s horas atrás',
    iWantEnableStoreUserQuery: 'Quero ativar a consulta de usuários da loja',
    iWantToPostStatistics: 'Quero publicar estatísticas',
    identification: 'Identificação',
    identificationText: 'Identificação',
    imageSizeExceed: 'Por favor, envie uma imagem com uma largura e altura de %s',
    imageUploadFailed: 'Falha no upload de imagens',
    immediateRelease: 'Divulgação Imediata',
    immediateSend: 'Envie agora',
    imporFailedOfTableHeader: 'A importação falhou.  Cabeçalho do ficheiro não corresponde',
    import: 'importar',
    importDetails: 'Detalhes da pergunta',
    importExcel: 'Importar EXCEL',
    importFail: 'Falha na importação',
    importStatus: 'Estado de importação',
    importSuccessful: 'Importação bem-sucedida',
    importTemplate: 'Transferência do modelo',
    importer: 'importador',
    importerAccountOperationRecord: 'Operação da conta de importador e registo de início de sessão',
    importerAvatar: 'Avatar do importador',
    importerDisplayName: 'Nome de apresentação do importador',
    importerEnquiry: 'Consulta do importador',
    importerManagement: 'Gestão do Importador',
    importerOperationRecords: 'Registos de Operação do Importador',
    importing: 'Importando...',
    inProcess: 'contramedidas',
    inProgress: 'em progresso',
    individualCenter: 'Centro pessoal',
    informationCategory: 'Categoria de informação',
    informationCategoryList: 'Lista de categorias de informação',
    informationCategoryQuery: 'Consulta de categoria de informação',
    informationContent: 'Conteúdo informativo',
    informationContentList: 'Lista de conteúdo informativo',
    informationCotnentQuery: 'Consulta de conteúdo de informação',
    informationCover: 'Capa informativa',
    informationDetails: 'Informação Detalhes',
    informationImage: 'imagem de capa',
    informationManagement: 'Gestão da Informação',
    informationTitle: 'Título da informação',
    informer: 'Informador',
    informerId: 'ID do informador',
    initialPassword: 'Palavra-passe inicial',
    inputAgreementContent: 'Por favor insira o conteúdo do acordo',
    inputCannotExceed20000: 'Pode inserir até 20000 caracteres',
    inputErrorEmoji: 'Não introduzir emoticons',
    installDeviceYouCan: 'A instalação deste dispositivo permite',
    installVehicleModelAdd: 'Adicionar Descrição do modelo de veículo retroinstalado',
    installVehicleModelDescription: 'Descrição do modelo adaptado',
    installVehicleModelEdit: 'Editar Descrição do modelo de veículo retroinstalado',
    instrumentLastedVersion: 'O display tft já é a versão mais recente',
    instrumentupgrade: 'Atualização da tela TFT',
    inteligentServiceReminder: 'Lembrete de Serviço Inteligente',
    intelligentInternetServiceIntroduction: 'Introdução ao serviço',
    intelligentServiceAgreement: 'Acordo de Serviço Inteligente',
    intelligentServices: 'Serviços inteligentes (detalhes do veículo, dados da viagem, OTA)',
    introText: {},
    introduction: 'Introdução',
    invalidVercode: 'Código de verificação inválido',
    invoicePreview: 'Pré-visualização da fatura',
    invoicing: 'Faturação',
    invoicingFailed: 'Falha na faturação',
    invoicingSucceeded: 'Faturação bem-sucedida',
    iovNotice1: 'As funções acima são baseadas no dispositivo de rede do veículo (T-Box), consulte o revendedor local para comprar e instalar',
    iovNotice2: 'As funções acima são diferentes de acordo com a configuração de cada modelo e a região onde está localizado. Consulte o revendedor local para obter detalhes.',
    iovNotice3: 'Salve e registre o número do dispositivo com antecedência, o que é necessário ao vincular o dispositivo. Depois de concluir a ligação e a instalação, você poderá experimentar mais funções',
    isHelpful: 'Ajuda?',
    isStop: {},
    isSupportedChildOwnerOffMapDown: {},
    isSupportedNoOwnerOffMapDown: {},
    isSupportedOffMapDown: {},
    it_IT: 'italiano',
    iterativeVehicleFunctions: 'As partes principais do veículo podem ser atualizadas online remotamente para iterar continuamente as funções do veículo',
    jumpSettings: 'Configurações de salto',
    jumpTarget: {},
    jumpToWeb: {},
    jumpUrl: {},
    justNow: 'Agora mesmo',
    keySharing: 'Chave digital e partilha de chaves',
    kolUser: 'Utilizador KOL',
    kolUserList: 'Lista de utilizadores KOL',
    kolUserManagement: 'Gestão de utilizadores KOL',
    kolUserQuery: 'Consulta do utilizador KOL',
    language: 'Linguagem',
    language1: 'Língua associada',
    languages: 'Língua',
    lastLoginTime: 'Última hora de início de sessão',
    lastModifiedBy: 'Última modificação por',
    lastUpdateTime: 'Última hora atualizada',
    latitude: 'Latitude',
    launchActivity: 'Atividade de lançamento',
    likeNumber: 'Número de curtidas',
    linkAddress: {},
    linkUrlDescription: {},
    linkedOrder: 'Pedido vinculado',
    listDisplayImages: 'Exibição de lista',
    listOfImporters: 'Lista de importadores',
    listOfQuestion: {},
    listShowStoreCoverPic: 'Listar a imagem de capa da loja',
    loadMore: 'Carregar mais',
    loadSuccess: 'Carregamento concluído',
    loading: 'Carregando',
    locationFail: {},
    log: 'Registo',
    login: 'Login',
    loginCountry: 'País/região de login',
    loginSuccessfully: 'Login com sucesso',
    logout: 'Sair do status de login',
    longitude: 'Longitude',
    loosing: 'Atualizando dados...',
    lowCompatibleVersion: 'Versão mínima compatível',
    mail: 'E-mail',
    male: 'Homem',
    manualReviewStatus: 'Estado da revisão manual',
    mapManage: {},
    marketDataOfdealerStores: 'Dados de mercado das lojas de concessionários',
    masteringCyclingData: 'Dados de equitação mestre',
    maximum: 'Máx.',
    maximumBannerCountTip: 'Um máximo de %s banners podem estar online ao mesmo tempo.  Por favor, remova pelo menos um primeiro.',
    maximumMileage: 'Quilometragem máxima resgatável',
    maximumValue: 'Máximo',
    menuFunctionName: 'Nome função',
    menuIcon: 'Ícone do menu',
    messagePush: 'Mensagem push',
    messagePushDeleteAsk: 'Tem a certeza de que pretende apagar este push?',
    messagePushDownloadTemplate: 'Descarregue primeiro o modelo e carregue o ficheiro depois de preencher o ficheiro do modelo.  O tamanho do ficheiro é limitado a 2M.  Se o envio não for bem sucedido, reduza o conteúdo de forma adequada',
    messageWithdrawAsk: 'Quer retirar este push?',
    middle: 'meio',
    min: 'Min',
    minAgo: '%s min atrás',
    minimum: 'Mín.',
    minimumValue: 'Mínimo',
    modelDetail: 'Detalhes do modelo',
    modifyFail: 'Falha na modificação',
    modifyPassword: 'Modificar palavra-passe',
    modifySuccess: 'Modificação bem sucedida',
    monday: 'Segunda-feira',
    more4pic1video: 'Máximo de 4 imagens / 1 vídeo',
    moreDetailsConsultDealerStore: 'Para mais detalhes, consulte a loja do seu concessionário',
    morning: 'Manhã',
    motoPlay: 'MotoPlay (serviço de navegação e projeção de ecrã baseado no Google)',
    motoPlayAgreement: 'Estado do Acordo MotoPlay',
    motoplatNavigationScreen: 'Projeção de ecrã de navegação MotoPlay',
    motoplayServicePay: 'Pagamento para MotoPlay',
    motoplayServiceResetTimeRule: 'O tempo de redefinição de MotoPlay não pode ser posterior ao tempo atual',
    motorcycle: 'veículo de duas rodas',
    moveDown: 'Mover para baixo',
    moveLongPressMap: {},
    moveMapSelectPoint: {},
    moveTo: 'Mover para',
    moveToBottom: 'Mover para o fundo',
    moveToTop: 'Mover para o topo',
    moveToTopStatus: 'Ir para o topo',
    moveTop: 'Configuração do topo',
    moveUp: 'Mover para cima',
    multimedia: 'Multimédia',
    mustInteger: {},
    mute1Day: 'Silenciado durante 1 dia',
    mute2Days: 'Silenciado durante 2 dias',
    mute30Days: 'Silenciado durante 30 dias',
    mute3Days: 'Silenciado durante 3 dias',
    mute7Days: 'Silenciado durante 7 dias',
    muting: 'Silenciamento',
    nameOfImporter: 'Nome do importador',
    navigation: 'Navegação no mapa',
    nearLoginTime: 'Última hora de início de sessão',
    needPopup: 'Precisa de janela pop-up',
    negativeNum: 'Crítica ruim',
    networkException: 'Exceção de rede',
    newAddFail: 'Adição falhou',
    newAddSuccess: 'adicionado com sucesso',
    newBanner: 'Novo Banner',
    newCancellationAgreement: 'Novo acordo de cancelamento',
    newEmail: 'Novo e-mail',
    newEmailEqualsValidate: 'A nova conta de e-mail não pode ser igual à conta original',
    newFunctionIntro: {},
    newMenuFunction: 'Nova função',
    newModelSeries: 'Nova série de modelos',
    newPassword: 'Nova Palavra-passe',
    newPasswordNotEqual: 'A nova senha digitada duas vezes é inconsistente, digite novamente',
    newQuestionType: {},
    newStoreNumber: 'Número de novas lojas',
    newTopic: 'Novo tópico',
    newUnbindingCommitment: {},
    nextStep: 'Próximo',
    nickName: 'Alcunha',
    no: 'Não',
    noContent: 'Nenhum conteúdo relacionado',
    noContent2: 'Sugira a alteração de palavras-chave ou',
    noData: 'Sem dados',
    noExchangeRecord: 'Ainda não há registo de resgate',
    noFeedbackRecord: 'Neste momento não há registos de feedback.',
    noJump: 'Sem salto',
    noLog: 'Sem registo',
    noMores: 'Não mais',
    noNeedPopup: 'Não são necessários pop-ups',
    noOkToFeedback: 'Não resolvido, quero dar feedback',
    noOwnerScore: 'Avaliações de não proprietários',
    noPass: 'Rejeitar',
    noSendPeople: 'Sem remetente',
    noSortingPermission: 'Sem permissão de ordenação',
    noSupportMapDown: {},
    noThisPermission: 'Sem permissão para esta operação',
    noUserSelected: 'Nenhum usuário selecionado, não é possível enviar',
    nofiledSeviceContent: {},
    nonOwner: 'Não proprietário',
    nonVehicleOwnerCharged: {},
    none: 'Nenhum',
    normal: 'Normal',
    notAllowImageAndVideo: 'O vídeo não pode ser seleccionado ao seleccionar as imagens',
    notAllowed: 'Não permitido',
    notBeLessOrEqual: 'Não pode ser inferior ou igual a',
    notDeleted: 'Não cancelado',
    notDistributedYet: 'Não distribuído',
    notEnabled: 'Não habilitado',
    notHelpful: {},
    notLessThan: 'Não pode ser inferior a',
    notRecommended: 'Não recomendado',
    notReleasedYet: 'Ainda não lançado',
    notStarted: {},
    'notSupportT-Box': 'Lamentamos, o seu veículo não suporta T-Box',
    notTop: 'Não para o topo',
    notice: 'Perceber',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. In order to continuously improve your service experience, we are committed to enhancing service quality and implementing innovative improvements. In this context, we have made business adjustments and hereby notify you that as of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In order to ensure that your service experience is not affected, we have launched a brand-new CFMOTO RIDESYNC App. We hope you can continue to enjoy our new services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Os números de versão não podem ser todos 0',
    obtainVerificationCode: 'Obter código de verificação',
    officiaAndKolList: 'Lista oficial/KOL',
    officialAccount: 'Conta oficial',
    officialAccountAuth: 'Autenticação de conta oficial',
    officialIrKOLSearch: 'Busca Oficial/KOL',
    officialKolAuth: 'Autenticação oficial/KOL',
    offline: 'Offline',
    offlineAlready: 'Off-line',
    offlineTime: 'Hora offline',
    offlineTimeMustBeGreaterThan: 'A hora offline deve ser superior a',
    ok: 'Ok',
    oldPassword: 'Senha Antiga',
    onLineAlready: {},
    oneMonths: 'Um mês',
    oneYear: 'Um ano',
    online: 'Online',
    onlyFourWheel: 'Apenas quatro rodas',
    onlyTwoWheel: 'Apenas duas rodas',
    openEveryCount: {},
    openEveryDay: {},
    openProductType: {},
    operationRecord: 'Registo de operação',
    operationTime: 'Tempo de funcionamento',
    operations: 'Operações',
    operator: 'Operador',
    operattor: 'Operador',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Atualização opcional',
    orderFeedBackNum: 'Número de feedback de pedido',
    orderList: {},
    orderMange: {},
    orderNum: {},
    orderQuestion: 'Descreva a data e os detalhes do problema e carregue uma ou mais capturas de ecrã. Para problemas de pagamento, carregue também o comprovativo da dedução',
    originalEmail: 'E-mail original',
    otaUpgradeVehicle: 'Veículo de atualização OTA',
    otaUpgradeVehicleDesc: 'Os principais componentes do veículo podem ser atualizados remotamente para iterar continuamente o desempenho do veículo.',
    other: 'Outro',
    over: 'sobre',
    owner: 'com carro',
    ownerIdHomepageImage: 'Página principal do cartão de identificação, carta de condução ou passaporte que contém informações pessoais de identificação.',
    parameterConfiguration: 'Configuração de parâmetros',
    partialImportFailed: 'Importação parcial falhou',
    pass: 'Aprovar',
    passValidateDeleteAccount: 'Verificação de identidade bem sucedida! Clique no botão Enviar pedido na parte inferior para solicitar  a exclusão da conta',
    password: 'Palavra-passe',
    passwordRuleText: '8-20 caracteres, deve conter letras maiúsculas e minúsculas em inglês, números, caracteres especiais',
    passwordRules: 'Regras de senha',
    paySetting: {},
    payStrategy: {},
    paymentLastDayBasedata: 'Duração paga da edição standard',
    paymentLastDayMotoplay: 'Duração paga do MotoPlay',
    peleaseEnterProvince: 'Introduza uma província/estado',
    pendSend: 'Pendente',
    pending: 'Pendente.',
    pendingSubmit: 'Envio Pendente',
    permanentMuting: 'Silenciado permanentemente',
    phoneModel: 'Modelo',
    phoneNum: 'número de telefone',
    phoneNumber: 'Número de telefone',
    phoneOrEmail: 'Número de telefone/E-mail',
    phoneOrEmailImportTemplate: 'Modelo de importação de número de telemóvel/endereço de e-mail',
    phoneOrEmailNotRegistered: 'Este número de telemóvel ou endereço de e-mail não está registado',
    phoneOrEmailOrUserId: 'Número de telemóvel/endereço de e-mail/ID do utilizador',
    picture: 'Foto',
    pl_PL: 'polonês',
    pleaseAddImage: 'Adicione arquivos de imagem',
    pleaseAddVideoFile: 'Adicione arquivos de vídeo',
    pleaseEnter: 'Por favor entre',
    pleaseEnterAccountInfo: 'Por favor insira as informações da conta',
    pleaseEnterAmount: {},
    pleaseEnterCity: 'Por favor, introduza uma cidade',
    pleaseEnterEmail: 'Por favor, indique o seu endereço de e-mail',
    pleaseEnterEmailAdress: 'Introduza o endereço de email',
    pleaseEnterIntro: 'Por favor insira a introdução',
    pleaseEnterLatAndLong: 'Por favor, introduza a latitude e longitude',
    pleaseEnterNewPassword: 'Por favor introduzir a nova palavra-passe',
    pleaseEnterPassword: 'Introduza a palavra-passe',
    pleaseEnterPhone: 'Por favor, digite seu número de telefone',
    pleaseEnterQuestionDescription: 'Por favor introduza uma descrição do seu problema',
    pleaseEnterRealname: 'Por favor, digite seu nome verdadeiro',
    pleaseEnterRemark: 'Insira comentários',
    pleaseEnterServePhone: 'Introduza o número de telefone de serviço',
    pleaseEnterStoreAddressDetail: 'Introduza o endereço pormenorizado',
    pleaseEnterStoreIntroduce: 'Introduza a introdução da loja',
    pleaseEnterStoreName: 'Introduza o nome da loja',
    pleaseEnterStoreRemarkName: 'Introduza o nome de observação da loja',
    pleaseEnterTitle: 'Por favor insira um título',
    pleaseEnterUsername: 'Indicar um Nome de utilizador',
    pleaseEnterVercode: 'Introduza o código de verificação',
    pleaseEnterVersion: 'Insira o número da versão',
    pleaseEnterVersionIntroduction: 'Insira a introdução da versão',
    pleaseEnterVideoDetail: 'Insira os detalhes do vídeo',
    pleaseEnterVin: 'Por favor insira o VIN',
    pleaseInputWord: 'Por favor, digite a palavra-chave',
    pleaseLoginFirst: 'Faça login primeiro',
    pleaseRepeatNewPassword: 'por favor, repita a nova senha',
    pleaseSelect: 'por favor escolha',
    pleaseSelectAuthAccount: 'Selecionar conta de autenticação',
    pleaseSelectBusinessHours: 'Por favor, seleccione o horário de abertura',
    pleaseSelectCity: 'Por favor, selecione a cidade',
    pleaseSelectCountry: 'Por favor, selecione o país',
    pleaseSelectCurrency: {},
    pleaseSelectMatchingMultimediaContent: 'Selecione o conteúdo multimédia correspondente',
    pleaseSelectPayChannel: {},
    pleaseSelectProblemWhere: 'Seleccione um cenário em que o problema ocorre',
    pleaseSelectProducType: {},
    pleaseSelectProvince: 'Por favor, selecione a província/o estado',
    pleaseSelectQueType: 'Seleccione o tipo de pergunta',
    pleaseSelectReportReason: 'Selecionar o motivo da comunicação',
    pleaseSelectService: 'Selecione primeiro um serviço',
    pleaseSelectStatus: 'Selecionar o estado',
    pleaseSelectStoreType: 'Por favor, seleccione o tipo de loja',
    pleaseSelectTimedSendTime: 'Selecione o horário de envio',
    pleaseSelectUserTheList: 'Selecione um utilizador da lista',
    pleaseSelectVehicle: 'Selecione um veículo',
    pleaseSelectVehicleConfig: {},
    pleaseSelectlinkedOrder: 'Por favor, selecione um pedido vinculado.',
    pleaseSelectupgradeType: 'Selecione o método de atualização',
    pleaseSureType2: 'Certifique-se de que tudo em',
    pleaseUpload: 'Envie por favor',
    pleaseUploadPicVideo: 'Carregue imagens/vídeos',
    pleaseUserTimeFill: 'Por favor, preencha de acordo com o tempo do usuário final',
    popUpFrequencyType: 'Formulário de janela pop-up',
    popUpFrequencyValue: 'Frequência de pop-up',
    popUpFrequencyValueValid: 'Selecione os dias de frequência',
    popUpReminder: 'Se deve aparecer um lembrete',
    popupArea: 'Faixa de usuário pop-up',
    popupCreate: {},
    popupDayOne: 'Uma vez por número definido de dias',
    popupEdit: {},
    popupFrequency: {},
    popupManagement: {},
    popupOne: {},
    popupPosition: {},
    popupStatus: {},
    popupTarget: {},
    popupTime: {},
    popupTitle: {},
    positiveNum: 'Boas críticas',
    postComment: 'Comentário da publicação',
    postContent: 'Conteúdo da publicação',
    postId: 'ID da publicação',
    postList: 'Lista de publicações',
    postManagement: 'Gestão de publicações',
    postSearch: 'Pesquisa de postagem',
    posts: 'Postagens',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Detalhes do conteúdo da política de privacidade',
    privacyPolicy: 'Política de Privacidade',
    privacyPopupAgree: 'Obtenha novamente o consentimento do usuário com a política de privacidade por meio de uma janela pop-up',
    privacyVersion: 'Versão da Política de Privacidade',
    privacyVersionList: 'Lista de versões da política de privacidade',
    problemaDes: 'Descrição do problema',
    processMethod: 'Métodos de processamento',
    processReason: 'Motivo do processamento',
    processReasonDetails: 'Detalhes do motivo do processamento',
    processRecord: 'Registo de processamento',
    processReport: 'Relatórios de processo',
    processSolution: 'Solução de processamento',
    processUser: 'Utilizador do processo',
    processed: 'Processados',
    productDetails: {},
    productTime: 'tempo de produção',
    prohibitDecimalsAndNegative: {},
    pt_PT: 'Português',
    publishInformation: 'Publicar informações',
    publishPosts: 'Lançar publicações',
    pullBefore: 'Puxe para baixo para atualizar.',
    pulling: 'Liberar atualização agora',
    purchaseAndInstall: 'Compre e instale',
    pushConfiguration: 'Configuração push',
    pushContent: 'Enviar conteúdo',
    pushList: 'Lista de push',
    pushMode: 'Modo de push',
    pushNow: 'Push agora',
    pushQuery: 'Consulta push',
    pushRecord: 'Registo de push',
    pushScope: 'Alcance de push',
    pushTime: 'Tempo de push',
    pushTimeDifferenceAsk: 'O horário de envio escolhido pode fazer com que alguns usuários não consigam receber esse push devido a diferenças de horário. Tem certeza de que deseja salvar?',
    pushTitle: 'Título de push',
    pushed: 'Empurrado',
    pushing: 'Em push',
    quantity: 'Quantidade',
    query: 'Pesquisar',
    question: {},
    questionInquiry: {},
    questionType: 'Tipo de pergunta',
    questionTypeList: {},
    questionTypeTemplate: {},
    quickRelease: 'Lançamento rápida',
    ranking: 'Classificação',
    ratingWarn1:
      'Para usuários proprietários de veículos, o controle de serviço inteligente correspondente ao país/região no plano de fundo de gerenciamento não foi ativado ou o serviço de serviço inteligente não expirou após ser ativado. O veículo está on-line e possui',
    ratingWarn2: 'ou mais registros completos de pedalada (o início e o final de cada pedalada são eventos relatados), um pop-up aparecerá quando o usuário sair do My Cycling e retornar à página inicial.',
    reUpgrade: 'Re-upgrade',
    readAgree: 'Leia e concorde com',
    readAndAgree: 'Ler e concordar',
    readAndAgreeTo: 'Eu li e concordei com',
    readDeleteStep: 'compreenda os tipos de dados que iremos eliminar ou conservar, bem como quaisquer períodos de conservação adicionais',
    realname: 'Nome real',
    reasonForReport: 'Motivo',
    receiveCarReminderMessage: 'Receber alertas de mensagens do veículo',
    rechargeAmount: {},
    rechargeChannel: {},
    rechargeStatus: {},
    rechargeTime: {},
    recharged: {},
    recipients: 'Destinatário',
    recipientsNum: 'Escopo do destinatário',
    recommended: 'Recomendado',
    recommendedStatus: 'Estado recomendado',
    redeemableServiceHours: 'Horas de serviço resgatáveis',
    redemptionMileage: 'Quilometragem disponível para resgate',
    redemptionRatio: 'Rácio de resgate',
    redemptionTime: 'Tempo de resgate',
    redirectUrl: {},
    refreshInterval: 'Intervalo de actualização',
    refreshSend: 'reenviar',
    refundFailed: {},
    refunded: {},
    refunding: {},
    refused: 'Rejeitado',
    registerDate: 'Hora do registo',
    rejected: 'Rejeitado.',
    releaseContent: 'Conteúdo do lançamento',
    releaseMethod: 'Método de publicação',
    releaseMute: 'Libertar o modo silencioso',
    releaseTime: 'Tempo de liberação：',
    released: 'Lançado',
    releasedBy: 'Lançado por',
    remainServiceHavExpired: 'Tempo restante até que o serviço inteligente expire',
    remainingAvailableMileage: 'Quilometragem disponível restante',
    remark: 'Notas',
    rememberPassword: 'Lembrar palavra-passe',
    reminder: 'Lembrete',
    remove: 'Remover',
    removeOnlinUpgrade: 'Veículo de atualização on-line remoto',
    repeatNewPassword: 'Introduzir novamente a palavra-passe',
    replaceTBOX: 'Substituição TBOX',
    replied: 'Respondeu',
    reply: 'Responder',
    report: 'Relatório',
    reportList: 'Lista de relatórios',
    reportManagement: 'Gestão de relatórios',
    reportReason: 'Motivo da comunicação',
    reportReasonDetails: 'Detalhes do motivo da comunicação',
    reportReasonPlaceholder: 'Escreva o que pretende relatar, 0-1500 palavras',
    reportSearch: 'Pesquisa de relatórios',
    reportSuccessful: 'Denúncia bem sucedida, trataremos do assunto o mais rapidamente possível',
    reportTime: 'Hora do relatório',
    reportType: 'Tipo de relatório',
    reportedContent: 'Conteúdo comunicado',
    reportedUser: 'Utilizador denunciado',
    reportedUserId: 'ID do utilizador denunciado',
    requestTimedOut: 'A solicitação expirou',
    resend: 'Reenviar',
    resendTo: 'Reenviar para',
    reset: 'Repor',
    resetItem: 'Redefinir item',
    resetTime: 'Hora de redefinição do serviço inteligente',
    resetWarn: 'Após a redefinição, o período gratuito dos serviços inteligentes do veículo será recalculado e entrará em vigor com base na hora atual (hora do navegador). Por favor, confirme se deseja redefinir.',
    return: 'Voltar',
    review: 'Revisão',
    reviewApproved: 'Revisão aprovada',
    richText: {},
    ro_RO: 'romena',
    roleDescription: 'Descrição',
    roleName: 'Nome',
    rolePermission: 'Permissões',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'russo',
    safeRemind: 'Para proteger a segurança da sua conta, não submeta aqui informações pessoais sensíveis, tais como senhas de contas, etc.',
    satelliteMap: 'Mapa de satélite',
    saturday: 'Sábado',
    save: 'Guardar',
    saveAndPreview: 'Salvar e visualizar',
    saveAsDraft: 'Guardar como rascunho',
    saveFail: 'Falha ao salvar',
    savePicture: 'Salvar foto',
    saveSettings: 'Salvar configurações',
    saveSuccess: 'Salvado com sucesso',
    saveVideo: 'Salvar vídeo',
    scanQrcodePreview: 'Digitalize o código QR abaixo com seu celular para visualizar',
    screenNavigationGuidance: 'Configurar instruções',
    sdkStatement: 'Declaração SDK',
    search: 'Pesquisar',
    searchRecords: 'Pesquisa histórica',
    secondaryMenu: 'Menu secundário',
    securityMessage: 'As informações acima são usadas apenas para verificação de identidade, a CFMOTO protege suas informações.',
    securityServices: 'Serviços de segurança (posicionamento em tempo real, geo-fence, alarme de avaria)',
    select: 'Selecionar',
    selectAccount: 'Selecionar conta',
    selectAll: 'Selecione todos',
    selectAuthentication: 'Selecionar a autenticação',
    selectChannelType: 'Selecione um canal de feedback',
    selectCountry: 'Selecionar país',
    selectData: 'Seleccione os dados que pretende eliminar e clique no botão Enviar na parte inferior para enviar o seu pedido de eliminação de dados.',
    selectDate: 'Selecione a data',
    selectEnableStatus: {},
    selectFeedBackState: 'Selecione o status de processamento de feedback',
    selectFeedbackType: 'Seleccione un tipo de comentario',
    selectJumpTarget: {},
    selectLanguage: 'Por favor, selecione o idioma',
    selectOneCarType: 'Selecione pelo menos um modelo',
    selectPoint: {},
    selectPopupFrequency: {},
    selectPopupPosition: {},
    selectPopupTarget: {},
    selectPopupTime: {},
    selectRejectReason: 'Selecione um motivo de rejeição',
    selectTheLanguage: 'Seleccionar idioma',
    selectTime: 'selecionar tempo',
    selectUser: 'Selecione usuários',
    selectVehicle: 'Selecionar veículo',
    selectedMileage: 'Quilometragem selecionada',
    selectedMileageRedemption: 'Selecione quilometragem para resgatar',
    selectionOfImporter: 'Seleção do importador',
    sendNumberDescription: 'Número de dispositivos válidos onde a AWS Cloud criou tarefas de envio;',
    sendNumberDescription0: 'Entre os dispositivos de destino efetivos, o servidor Aurora cria com sucesso o número de dispositivos para enviar tarefas',
    sendNumberVolume: 'Número de envio',
    sendTo: 'Enviar para',
    sendType: 'Modo de envio',
    sendUserNum: 'Número de envio',
    sending: 'Ao enviar',
    serial: 'Não.',
    seriesBackground: {},
    seriesDesc: {},
    seriesIntroduction: 'Introdução da Série',
    seriesName: {},
    seriesShowcase: 'Apresentação da Série',
    seriesUplodImgRule: {},
    seriousAlarm: 'Alarme grave',
    serviceDays: 'Dias de serviço',
    serviceDetail: 'Detalhes do serviço inteligente',
    serviceExpiration: 'Os seus serviços inteligentes expiraram',
    serviceHavExpired: 'Serviços inteligentes expirados',
    serviceIntroduction: 'Introdução ao serviço',
    serviceReset: 'Redefinição de serviço inteligente',
    serviceText: 'Serviço',
    settingSuccess: 'Definir com sucesso',
    shareNumber: 'Número de compartilhamentos',
    sheet: 'Zhang',
    show: 'Ver',
    showPicturesOfVideos: 'Mostrar fotos/vídeos',
    showToast1: 'A quilometragem restante não é suficiente para resgatar 1 dia de serviço',
    showToast2: 'É necessário pelo menos 1 dia de serviço para o resgate',
    showToast3: 'O parâmetro não existe ou é nulo',
    showroomModel: 'Modelos de sala de exposições',
    showroomModelList: 'Lista de modelos de showroom',
    showroomModelQuery: 'Consulta de modelo de showroom',
    showroomUploadRules: 'O requisito de formato de imagem é jpg/jpeg/png, a proporção da imagem é 9:19,5, o tamanho não excede 5 MB e o tamanho do vídeo não excede 50 MB',
    signOut: 'Terminação automática',
    singapore: 'Cingapura',
    sixMonths: 'Seis meses',
    slideToRight: 'desliza para a direita',
    smartServices: 'Serviços Inteligentes',
    someUser: 'Alguns utilizadores',
    sort: 'Ordenar',
    source: 'Fonte',
    sr_YU: 'sérvio',
    standardAgreement: 'Estado do Acordo Standard Edition',
    startCalculateTimeBasedata: 'Tempo de reinicialização da edição standard',
    startCalculateTimeMotoplay: 'Tempo de reinicialização do MotoPlay',
    startChecking: 'Iniciar a Verificação',
    startTime: 'Hora de início',
    statisticalTime: 'Período estatístico',
    status: 'Estado',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: {},
    store: {},
    storeAddressCountryTip: 'Observação:  Este endereço da loja é a única base para os utilizadores o encontrarem.  Preencha cuidadosamente para garantir que o endereço está correto',
    storeAddressDetail: 'Endereço da loja',
    storeAddressDetailTip: 'Exemplo: endereço pormenorizado:   Nº 116, Rua Wuzhou, Zona de Desenvolvimento Económico de Yuhang, Hangzhou',
    storeAddressPosition: 'Latitude e longitude',
    storeAddressPositionTip:
      'Longitude: a parte inteira da longitude é um número inteiro de -180 a 180, e a parte decimal é um número decimal que não excede 15 dígitos.\nLatitude: a parte inteira da latitude é um número inteiro de -90 a 90, e a parte decimal não excede 15 casas decimais.',
    storeBusinessType: 'Tipo da loja',
    storeImage: 'Imagem da loja',
    storeImportTemplateText:
      'Primeiro, baixe o modelo, preencha as informações da loja do revendedor no arquivo de modelo e, em seguida, carregue o arquivo; o tamanho do arquivo é limitado a 1 MB; se a submissão falhar, reduza o conteúdo ou faça o upload em lotes',
    storeIntroduce: 'Apresentação da loja',
    storeList: 'Lista de lojas',
    storeMange: 'Gestão da loja',
    storeName: 'Nome da loja',
    storeNameTip: 'Observação:  Selecione um idioma suportado pelo sistema para preencher o nome da loja',
    storeQueryUserStatistics: 'Estatísticas de consulta de utilizadores da loja',
    storeRemarkName: 'Nome de observação da loja',
    storeRemarkNameTip: 'Observação:  Se o idioma suportado pelo sistema não atender às suas necessidades, é possível entrar aqui o nome de observação da loja no idioma desejado.',
    storeSearch: 'Consulta de lojas',
    storeServicePhone: 'Número de telefone do serviço',
    storeServicePhoneTip: 'Observação:  Este número é utilizado para o contacto telefónico com o cliente. Certifique-se de que o número de telefone está correto.',
    storeServiceTime: 'Hora de abertura',
    storeStatistics: 'Estatísticas da loja',
    storeUploadImageRequire: 'Requisitos de formato de imagem para jpg/jpeg/png, recomenda-se que o tamanho de uma única imagem não exceda 5MB, uma única importação de até 9, pode ser importada mais do que uma vez, o número total de não mais do que 9',
    storefront: 'Loja',
    submissionFailed: 'Envio falhou, por favor, tente novamente.',
    submit: 'Enviar',
    submitAccountDeleteApply: 'Envie o pedido de exclusão da conta',
    submitDataDeleteApply: 'Envie o pedido de eliminação de dados',
    submitFeedback: 'Enviar feedback',
    submitForReview: 'Enviar para revisão',
    submitted: 'Enviado',
    successful: 'Bem sucedido',
    sunday: 'Domingo',
    supportMapDown: {},
    supportedChannel: {},
    sureAgree: 'Concordar ou não?',
    sureBackApply: 'Confirmar a retirada do pedido de exclusão de conta',
    sureDelete: 'Uma vez excluído, ele não pode ser recuperado. Tem certeza de que deseja excluí-lo',
    sureDeleteData: 'Tem a certeza de excluir os dados selecionados? Uma vez confirmados, os dados são imediatamente apagados e não podem ser recuperados',
    sureDeleteSeries: {},
    sureDeleteSetting: {},
    sureDeleteStoreInfo: 'Confirmar a eliminação das informações desta loja? Após a eliminação, as informações não poderão ser recuperadas',
    sureReject: 'Tem a certeza de que quer rejeitar?',
    sureSuspend: 'O envio será interrompido após o término. Tem certeza de que deseja encerrar',
    suspend: 'Encerrar',
    sv_SE: 'sueco',
    switchLanguage: 'Alterar idioma',
    system: 'Sistema',
    systemBusy: 'O sistema está ocupado, tente novamente mais tarde',
    systemVersion: 'versão do sistema',
    tboxInstall: 'Pós-instalação de Tbox',
    tboxIntro: 'T-Box é o dispositivo chave para realizar a função de conexão de rede inteligente dos veículos',
    teamConfigTip: {},
    threeMonths: 'Três meses',
    thursday: 'Quinta-feira',
    time: 'Hora',
    timeSend: 'Envio cronometrado',
    timedOffline: 'Temporizada off-line',
    timedPush: 'Push temporizado',
    timedRelease: 'Publicação programada',
    timedSendTime: 'Hora de envio',
    tips: 'Pontas',
    title: 'título',
    to: 'Para',
    toBeReleased: 'A ser lançado',
    topMenu: 'Menu de nível superior',
    topicContent: 'Conteúdo do tópico',
    topicList: 'Lista de tópicos',
    topicManagement: 'Gestão de tópicos',
    topicSearch: 'Pesquisa de tópicos',
    topicTitle: 'Título do tópico',
    totalAndlLayoutOfStores: 'Número total e disposição das lojas',
    totalClicks: {},
    totalNumber: 'Total de tempos',
    tr_TR: 'turco',
    triggerNum: 'Número de gatilhos',
    tuesday: 'Terça-feira',
    turnOn: 'Abrir',
    twoCarAndFourCarOfNumber: 'Número de utilizadores de veículos de duas e quatro rodas',
    twoCarOfNumber: 'Número de utilizadores de veículos de duas rodas',
    twoWheelConfig: {},
    twoWheeler: 'Veículo de duas rodas',
    twoWheelerAndFourWheeler: 'Veículos de duas e quatro rodas',
    twoWheelerMostClicks: 'Modelos de duas rodas com mais cliques',
    twoWheelowner: {},
    type: 'Tipo',
    typeMessage: 'tipo de feedback',
    types: 'Tipo',
    unbind: 'Não vinculado',
    unbindingCommitment: {},
    unbindingLabelRealName: 'Nome completo',
    unbound: 'Desvinculado.',
    understandRealtimeConditions: 'Receba vibrações do veículo e mensagens de lembrete de entrada e saída da cerca eletrônica e entenda o status do veículo em tempo real',
    uninstallTboxDesc: 'Para veículos que não possuem um T-Box instalado, você pode visualizar informações básicas do veículo, como número do chassi, número do motor e manual eletrônico após a ligação.',
    unitCurrencyPer: {},
    unitMonth: 'Mês',
    unlimited: 'Ilimitado',
    unpaid: {},
    unprocessed: 'Não transformado',
    unresolved: 'Ainda não consegue resolver? Clique',
    unspecified: 'Confidencialidade',
    upToTopics: 'Podem ser adicionados até %s tópicos',
    updateAuthenticationTime: 'Atualizar tempo de autenticação',
    updateBy: 'Atualizador',
    updateSuccess: {},
    updateTime: 'Hora da atualização',
    updating: 'atualizando',
    upgradeAgainDescription: 'A tarefa de atualização foi enviada novamente. Por favor, siga o 【Guia】 no topo da página atual para conectar a rede de exibição tft para atualizar.',
    upgradeAssistant: 'Ajuda',
    upgradeDescription: 'Quando uma nova versão for encontrada, siga o 【Guia】 no topo da página atual para conectar a rede de exibição TFT para atualizar.',
    upgradeSuccessful: 'Upgrade bem-sucedido',
    upgradeType: 'Método de atualização',
    upload: 'Carregar',
    uploadDisplayPicture: {},
    uploadFail: 'Carregamento falhou',
    uploadFailed: 'Falha no upload, tente outra rede',
    uploadFailedOfTry: 'Falha no upload, tente novamente',
    uploadFileMore1M: 'O tamanho do arquivo de upload não excede 1 milhão',
    uploadFiles: 'Carregar arquivo',
    uploadImageRules1To1: 'O formato de imagem é necessário para ser jpg/jpeg/png, com uma proporção de imagem de 1:1 e um tamanho máximo de 5MB',
    uploadLog: 'Carregar registo',
    uploadPicture: 'Carregar imagem',
    uploadQuantityExceed: 'O número de carregamentos excede o limite',
    uploadSuccessful: 'Carregar com sucesso',
    uploadTime: 'Hora do upload',
    uploadTip556_740: {},
    uploadVideoRules: 'Apenas o upload único de arquivos de vídeo é suportado. Recomenda-se que o tamanho de um único vídeo não exceda 50 MB.',
    uploadVideoRules4To3: 'Suporte ao formato de vídeo, proporção recomendada de 4: 3, tamanho não superior a 50MB',
    urlLink: 'Ligação URL',
    user: 'Utilizador',
    userAccount: 'Conta de utilizador',
    userEmail: 'E-mail',
    userGender: 'Género do utilizador',
    userId: 'ID do usuário',
    userIdTemplate: 'Modelo de Importação de ID de Usuário',
    userIdentity: 'ID',
    userLocalTime: 'Hora do utilizador final',
    userLogin: 'Início de sessão',
    userMobilePhone: 'Telefone celular',
    userModel: 'Modelo de utilizador',
    userName: 'Nome do utilizador',
    userName1: {},
    userNickname: 'Apelido do usuário',
    userNum: 'Número de usuário',
    userPhone: 'Número de telemóvel',
    userRealName: 'Nome verdadeiro',
    userReply: 'Resposta pendente do usuário',
    userStatus: 'Estado do utilizador',
    userType: 'Tipo de utilizador',
    userUnbind: 'Desv. utilizador',
    users: 'Usuários',
    vacationTime: 'Tempo de férias',
    validNumberVolume: 'Número de objetivos válidos',
    validNumerDescription: 'Número de dispositivos restantes após filtrar o grupo alvo selecionado para o envio de tarefas',
    validateAfter24Hours: 'Suporta apenas seleções de horário futuras dentro de 24 horas',
    validateEmail: 'Formato de endereço de e-mail incorreto, por favor, verifique.',
    validateImageRadio: 'Requisitos de formato de ficheiro de imagem:  %s, escala da imagem:  %s, não mais do que %s',
    validateImageSize: 'Requisitos de formato de ficheiro de imagem:  %s, tamanho de imagem recomendado:  %s, não mais do que %s',
    validatePhone: 'Erro no formato do número de telefone, verifique',
    validateVideo: 'Requisitos de formato de ficheiro de vídeo:  %s, não mais do que %s',
    validateVin: 'VIN incorreto, por favor, verifique.',
    validationCodeError: 'Erro no código de verificação',
    vechicleFirstBindTime: 'Tempo da primeira vinculação real do veículo',
    vehicleAlarmDetails: 'Detalhes do alarme do veículo',
    vehicleBindDuration: 'Duração da vinculação do veículo',
    vehicleBrochure: 'Folheto do veículo',
    vehicleColor: 'Cor do veículo',
    vehicleDetails: 'Detalhes do veículo',
    vehicleDrivingLicense: 'Certificado de Registro do Veículo.',
    vehicleFaultDetails: 'Detalhes de Anomalias do veículo',
    vehicleGallery: 'Galeria de veículos',
    vehicleGalleryEntranceConfiguration: 'A página do showroom de motocicletas do APP e as fotos da entrada da função da galeria do veículo são todas tiradas da seguinte configuração. Certifique-se de que as três fotos estejam concluídas na configuração.',
    vehicleGalleryEntranceSettings: 'Configurações de entrada da galeria de veículos',
    vehicleGalleryUploadRules: 'O requisito de formato de imagem é jpg/jpeg/png. Recomenda-se que o tamanho de uma única imagem não exceda 5 MB. Um máximo de 10 imagens podem ser importadas por vez. São permitidas múltiplas importações.',
    vehicleIdHomepageImage: 'Página principal do Certificado de Registro do Veículo com nome do proprietário e VIN.',
    vehicleModel: 'Modelo do veículo',
    vehicleModelAlbum: 'Álbum modelo',
    vehicleModelCategorySort: 'Classificar por categoria de veículo',
    vehicleModelDescription: 'Descrição do modelo',
    vehicleModelList: 'Lista de modelos',
    vehicleModelManagement: 'Gerenciamento de modelo de veículo',
    vehicleModelName: 'Nome do modelo',
    vehicleModelQuery: 'Consulta de modelo de veículo',
    vehicleModelSeries: 'Série de modelos',
    vehicleModelSorting: 'Classificação de modelo',
    vehicleModelType: 'Tipo de modelo',
    vehicleName: 'Nome do veículo',
    vehicleNetworkEquipment: 'Dispositivo de rede de veículos',
    vehicleOutboundCountry: 'País de saída do veículo',
    vehicleRemark: 'Observações do veículo',
    vehicleShareInstruction: 'Instruções de partilha de veículos',
    vehicleShareInstructionAdd: 'Instruções de partilha de veículos novos',
    vehicleShareInstructionEdit: 'Editar instruções de partilha de veículos',
    vehicleType: 'Número do motor',
    vehicleTypeSplicing: 'Modelo do feedback',
    vehicleUnbindingInstructions: 'Instruções para solicitar a desvinculação do veículo',
    verifyCodeSendFail: 'Falha ao enviar código de verificação',
    verifyCodeSendSuccess: 'Envio de código de verificação bem sucedido',
    versionCode: 'Número da versão',
    versionIntroduction: 'Introdução à versão',
    versionManage: 'Gerenciamento de versão',
    versionManageList: 'Lista de gerenciamento de versões',
    versionMangeTip:
      'Nota: Não é permitido criar uma versão maior que o número de versão atualmente publicado no mercado de aplicativos! O pessoal de operação e manutenção precisa aguardar o lançamento da versão mais recente no Google Play ou App Store e, em seguida, criar registros de versão correspondentes ao número da versão mais recente. Não é permitido criar registros antecipadamente.',
    versionPattern: 'O número da versão só pode ser inserido como um número inteiro de 0 a 999.',
    versionRequired: 'O número da versão não pode ficar vazio',
    vhDataBasicService: 'Serviço Básico de Dados do Veículo',
    video: 'Vídeo',
    videoContent: 'Conteúdo de vídeo',
    videoCover: 'Capa do vídeo',
    videoDetail: 'Detalhes do vídeo',
    videoDisplayImages: 'Exibição de vídeo',
    videoFile: 'Arquivo de vídeo',
    videoGuide: 'Configuração de inicialização de vídeo',
    videoImageValidate: 'Requisitos de formato de arquivo de imagem: png jpg jpeg, proporção de imagem 16:9, tamanho não superior a 5 MB',
    videoList: 'Lista de vídeos',
    videoMaxSizeValidate: 'O tamanho do vídeo não pode exceder 150 MB',
    videoSizeExceed: 'Por favor, envie um vídeo com uma largura e altura de %s',
    viewAllComment: 'Ver todos os comentários',
    viewCount: 'contagem de visualizações',
    viewCurrentLocation: 'Abra o APP para visualizar a localização atual do veículo a qualquer momento',
    viewCurrentLocation2: 'Abra o APP para visualizar a localização atual do veículo a qualquer momento, o que é conveniente para encontrar veículos de perto',
    viewDetails: 'Ver Detalhes',
    viewFeedBackRecords: 'Ver registros de feedback',
    viewLocation: 'Abra o APP para verificar a localização do veículo a qualquer momento',
    viewModel: {},
    viewPush: 'Ver empurrar',
    viewSeries: {},
    viewVehicleInfomation: 'Suporte para visualizar a pista de pilotagem diária, quilometragem, duração, velocidade e outras informações do veículo',
    views: 'Visualizações',
    vin: 'VIN',
    virginia: 'Virgínia',
    waitForReview: 'Aguarda revisão',
    waitUploading: 'Carregamento, por favor aguarde',
    waitingManualReview: 'Aguarda revisão manual',
    waitingOnline: {},
    waitingPush: 'Esperando',
    wednesday: 'Quarta-feira',
    whatOTA: 'O que é OTA？',
    whyUseNavigation: 'Como utilizar a navegação',
    whyUseSetting: 'Como fazer as configurações gerais do APP',
    withCountry: 'País/Região (IP)',
    withInformation: 'Com informações',
    withTBOX: {},
    withdrawn: 'Retirado',
    withoutCarOfNumber: 'Número de utilizadores sem carro',
    withoutTBOX: {},
    writeAccountToPass: 'Preencher as informações da conta e concluir a verificação da identidade',
    year: {},
    yes: 'Sim',
    youHaveFeedbackMessage: 'Você tem ** feedback do usuário que não foi efetivamente acompanhado, por favor, lide com isso a tempo',
    youthVehicleOwner: {},
    yoyGrowth: 'Aumento em relação ao ano anterior',
    zh_CN: 'chinês',
  },
};
